import { Tabs } from "antd";

export interface ZhInsetTabsProps {
    options: Array<{ label: string; value: string | number }>;
    active?: string | number;
    tip?: string;
    onChange?: (value: string | number) => void;
    onActiveChange?: (value: string | number) => void;
}

/** 内嵌页签，保留旧版 options、active 双向更新和提示文案契约。 */
export default function ZhInsetTabs({ options, active, tip, onChange, onActiveChange }: ZhInsetTabsProps) {
    const selected = active == null ? undefined : String(active);
    const handleChange = (key: string) => {
        const option = options.find(item => String(item.value) === key);
        if (!option) return;
        onChange?.(option.value);
        onActiveChange?.(option.value);
    };

    return (
        <div className="tabs_wrapper">
            <Tabs
                activeKey={selected}
                items={options.map(item => ({ key: String(item.value), label: item.label }))}
                onChange={handleChange}
            />
            {tip ? <div className="tabs-tip">{tip}</div> : null}
        </div>
    );
}
